import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { formatPrice } from "../../Functions/Price";

const CartStyle = styled(Link)`

    --n-primary-2: #0E3D5C;
    --n-grey-2: #E5E5E5;
    --n-grey-3: #CBCBCB;
    --n-grey-7: #979797;
    --n-grey-9: #5E5E5E;

    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: var(--body-2);
    box-shadow: 0px 4px 30px -4px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    flex-grow: 1;
    text-decoration: none;
    color: inherit;
    .good-image{
        display: block;
        position: relative;
        width: calc(100% - 22.54%);
        padding: 4.72% 11.27% ;
    }
    .good-desc{
        padding: 0 4.36%;
        text-align: right;
        font-size: 1rem;
    }
    .good-price{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: baseline;
        text-align: left;
        font-weight: 400;
        font-size: 1.5rem;
        padding: 6% 4.36%;
        gap: 0.3rem;
        .price {
            font-size: 1.1rem;
        }

    }
    .line{
        border-bottom: 1px solid var(--n-grey-2);
        width: 100%;
    }
    .shop-info{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: 4% 5.82%;
        width: calc(100% - 11.64%);
        .shop-logo{
            border: 1px solid var(--n-grey-2);
            width: 2rem;
            border-radius: 50px;
        }
        .shop-name{
            font-weight: 400;
            font-size: 0.8rem;
            color: var(--n-grey-7);
            margin-right: 1rem;
        }
    }
`



const GoodCartNew =(props)=>{
    let link = props.data.link.replace("https://luxinlux.com", "")
    return (
        <CartStyle to={link}>
            <img className="good-image" src={props.data.image} alt={props.data.name}/>
            <div className="good-desc">
                {props.data.name}    
            </div>
            <div className="good-price">
                {formatPrice(props.data.price)}    
                <div className="price">تومان</div>
            </div>
            <div className="line"></div>
            <div className="shop-info">
                <img className="shop-logo" src={props.data.shopImage} alt={props.data.shop}/>
                <span className="shop-name">{props.data.shop}</span>
            </div>
        </CartStyle>
    )
    

}
export default GoodCartNew;